<template>
  <div class="legalwrapper">
    <ContentDoc>
      <template #not-found>
        <div class="not-found">
          <h1>Ooops! It seems that page you are looking for is not here.</h1>
        </div>
      </template>
    </ContentDoc>
  </div>
</template>

<script setup lang="ts">
  import { definePageMeta } from '#imports'

  definePageMeta({
    layout: 'privacy'
  })
</script>

<style lang="scss" scoped>
  nav > a {
    display: block;
  }

  .not-found {
    h1 {
      line-height: 1;
    }
  }
</style>
